import React, { useState, useEffect } from 'react'
import { Button, Modal, Row, Col, Form, Alert, Card } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { GoogleMap, Marker, Polygon } from '@react-google-maps/api'

function MapTask(props) {

	const [task, setTask] = useState(props.task)
    const {t} = useTranslation('common')
    const mapContainerStyle = {
		width: '100%',
		height: '600px'
    }

    useEffect(() => {
		console.log('useEffect')
	}, [props.task])

    const onLoad = map => {
        console.log('onLoad')

		map.setZoom(5)
		map.setCenter({ lat: 62.5, lng: 17.5 })
    }

	const onMapClick = e => {
		console.log('onClick')

		var latLng = e.latLng.lat() + ";" + e.latLng.lng()
		var answer = task.answer

		switch (task.type) {
			case 'MAP_MARKER':
				answer = e.latLng.lat() + ";" + e.latLng.lng()
				break
			case 'MAP_MULTIPLE_MARKERS':
			case 'MAP_POLYGON':
				if (answer) {
					answer += "\n"
				}
				answer += e.latLng.lat() + ";" + e.latLng.lng()
				break
		}

		props.onChange({target: {type: "string", name: "answer", value: answer}}, props.task)
	}

	const onMarkerClick = e => {
		var latLngs = getLatLngs()
		var newLatLngs = latLngs.filter(latLng => latLng.lat != e.latLng.lat() || latLng.lng != e.latLng.lng())
		var newAnswer = newLatLngs.map(latLng => latLng.lat + ";" + latLng.lng).join("\n")

		props.onChange({target: {type: "string", name: "answer", value: newAnswer}}, props.task)
	}

	const getLatLngs = () => {
		var result = []
		var rows = props.task.answer.split("\n")
		rows.forEach(row => {
			result.push({
				lat: parseFloat(row.split(";")[0]),
				lng: parseFloat(row.split(";")[1])
			})
		})
		return result
	}

	const onDragEnd = (e, latLng) => {
		var latLngs = getLatLngs()
		latLngs.forEach(otherLatLng => {
			if (otherLatLng.lat == latLng.lat && otherLatLng.lng == latLng.lng) {
				otherLatLng.lat = e.latLng.lat()
				otherLatLng.lng = e.latLng.lng()
			}
		})
		var newAnswer = latLngs.map(latLng => latLng.lat + ";" + latLng.lng).join("\n")

		props.onChange({target: {type: "string", name: "answer", value: newAnswer}}, props.task)
	}

    return (
        <>
	        <GoogleMap
				mapContainerStyle={mapContainerStyle}
		        onLoad={onLoad}
		        options={{ minZoom: 3, zoomControl: true }}
		        onClick={onMapClick}>
		        { props.task && props.task.answer &&
		            <>
		                { props.task.type == 'MAP_MARKER' &&
				            <Marker
			                    position={getLatLngs()[0]}
			                />
				        }
				        { props.task.type == 'MAP_MULTIPLE_MARKERS' &&
				            <>
				                { getLatLngs().map(latLng => {
				                    return <Marker
				                        key={latLng.lat + "-" + latLng.lng}
					                    position={latLng}
					                    onClick={onMarkerClick}
					                    draggable={true}
					                    onDragEnd={e => onDragEnd(e, latLng)}
					                />
				                })}
				            </>
				        }
			            { props.task.type == 'MAP_POLYGON' &&
			                <>
			                    { getLatLngs().map(latLng => {
				                    return <Marker
				                        key={latLng.lat + "-" + latLng.lng}
					                    position={latLng}
					                    onClick={onMarkerClick}
					                    draggable={true}
					                    onDragEnd={e => onDragEnd(e, latLng)}
					                />
				                })}
				                <Polygon paths={getLatLngs()}/>
				            </>
				        }
	                </>
		        }
			</GoogleMap>
        </>
    )
}

export default MapTask